import { render, staticRenderFns } from "./SendBroadcast.vue?vue&type=template&id=20dbd7f0&scoped=true&"
import script from "./SendBroadcast.vue?vue&type=script&lang=js&"
export * from "./SendBroadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dbd7f0",
  null
  
)

export default component.exports